(function(){
    'use strict'

    angular.module("app.containers", []);

})()